import React from 'react';

import PropTypes from 'prop-types';
import PageTitle from '../../../components/pageTitle';
import Navigation from '../../../components/navigation';
import moment from 'moment';

const SimplePage = ({
  t,
  invoices,
  backgroundCover,
  enableCoverColor,
  backgroundColor,
  hasMore,
  onShowMore,
}) => (
  <React.Fragment>
    <section className="Blog2 boxs knwldgeBase_D">
      <PageTitle
        title={'Stripe invoices'}
        backgroundPage={backgroundColor}
        backgroundCover={backgroundCover}
        enableCoverColor={enableCoverColor}
      />
      <div className="container">
        <div className="Blog2inner boxs pdlr forlineBlog forlineBlogleft">
          <svg aria-hidden="true" focusable="false" style={{ width: 0, height: 0, position: 'absolute' }}>
            <linearGradient id="gradientfill" className={`emoj-list ${backgroundColor}`}>
              <stop offset="0%" stopColor="var(--color-stop-1)" />
              <stop offset="100%" stopColor="var(--color-stop-2)" />
            </linearGradient>
          </svg>
          <Navigation cssClass="leftKB" />
          <div className="middleKB">
            <div className="middleinner boxs">
              {!!invoices.length &&
              <table className="invoices-table">
                <tr>
                  <th>Date</th>
                  <th>Total</th>
                  <th>Status</th>
                  <th>Download</th>
                </tr>

                {invoices.map(invoice => (
                  <tr>
                  <td>{moment(invoice.created).format('MM/DD/YYYY HH:mm:ss')}</td>
                  <td><span className="pointer three-dots doctags pdf-tag">{invoice.total != 0 ? (invoice.total/100).toFixed(2) :  '0.00'} {invoice.currency}</span></td>
                  <td><span className="three-dots doc-file">{invoice.status}</span></td>
                  <td>{!!invoice.hosted_invoice_url && (<a target="_blank" href={invoice.hosted_invoice_url}><span className="fa fa-cloud-download"></span></a>)}</td>
                  </tr>
                ))}

              </table>}
              {!invoices.length && <div>{t('You don\'t have invoices yet.')}</div>}

              { hasMore && <div class="sndrqst boxs"><a href="#" onClick={onShowMore} class="sndrqstbtn sndsuprtbtn">Show more</a></div> }

            </div>
          </div>


        </div>
      </div>
    </section>
  </React.Fragment>
);

SimplePage.propTypes = {
  t: PropTypes.func.isRequired,
};

export default SimplePage;



// WEBPACK FOOTER //
// ./src/views/modules/stripeInvoices/Invoices.jsx